import moment from 'moment'
import { getFile } from '@/api/media'
import defaultMeta from '@/config/defaultMeta'

const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS'

const articleResolver = ({author, createdAt, updatedAt, section, tags}) => {
    const metadata = []

    if(author) {
        metadata.push({
            'property':  'article:author',
            'content':  author,
        })
    }

    if(createdAt) {
        metadata.push({
            'property':  'article:published_time',
            'content':  moment(createdAt).format(DATE_FORMAT),
        })
    }

    if(updatedAt) {
        metadata.push({
            'property':  'article:modified_time',
            'content':  moment(updatedAt).format(DATE_FORMAT),
        })
    }

    if(section) {
        metadata.push({
            'property':  'article:section',
            'content':  section,
        })
    }

    if(tags) {
        for (let i = 0; i < tags.length; i++) {
            metadata.push({
                'property':  'article:tag',
                'content':  tags[i],
            })
        }
    }

    return metadata
}

const opengraphResolver = ({title, description, type, image}) => {
    const metadata = []

    metadata.push({
        'name':  'og:title',
        'property':  'og:title',
        'content':  title,
    })

    metadata.push({
        'name':  'og:description',
        'property':  'og:description',
        'content':  description,
    })

    metadata.push({
        'name':  'og:type',
        'property':  'og:type',
        'content':  type,
    })

    metadata.push({
        'name':  'og:site_name',
        'property':  'og:site_name',
        'content':  'Ask4Games',
    })

    if(image) {
        metadata.push({
            'name':  'og:image',
            'property':  'og:image',
            'content':  getFile(image),
        })

        metadata.push({
            'name':  'og:image:url',
            'property':  'og:image:url',
            'content':  getFile(image),
        })

        metadata.push({
            'name':  'og:image:type',
            'property':  'og:image:type',
            'content':  'image',
        })

        metadata.push({
            'name':  'og:image:width',
            'property':  'og:image:width',
            'content':  '1024',
        })

        metadata.push({
            'name':  'og:image:height',
            'property':  'og:image:height',
            'content':  '768',
        })

        metadata.push({
            'name':  'og:image:alt',
            'property':  'og:image:alt',
            'content':  title,
        })
    }

    return metadata
}

const twitterResolver = ({title, description, image, author}) => {
    const metadata = []

    metadata.push({
        'name':  'twitter:card',
        'property':  'twitter:card',
        'content':  'summary_large_image',
    })

    metadata.push({
        'name':  'twitter:title',
        'property':  'twitter:title',
        'content':  title,
    })

    metadata.push({
        'name':  'twitter:description',
        'property':  'twitter:description',
        'content':  description,
    })

    if(author) {
        metadata.push({
            'name': 'twitter:site',
            'property': 'twitter:site',
            'content': author,
        })
    }

    if(image) {
        metadata.push({
            'name':  'twitter:image',
            'property':  'twitter:image',
            'content':  getFile(image),
        })

        metadata.push({
            'name':  'twitter:image:alt',
            'property':  'twitter:image:alt',
            'content':  title,
        })
    }

    return metadata
}

export default function(metaTags) {
    let {title, description, image, type, authorPage, authorTwitterNik, createdAt, updatedAt, section, tags} = metaTags || {}

    title = title || defaultMeta.title
    description = description || defaultMeta.description
    type = type || defaultMeta.type
    image = image || null

    if(arguments.length > 1) {
        for (let i = 1; i < arguments.length; i++) {
            const variant = arguments[i]

            if(!variant) continue

            if(variant['title']) {
                title = variant['title']
            }

            if(variant['description']) {
                description = variant['description']
            }

            if(variant['type']) {
                type = variant['type']
            }

            if(variant['image']) {
                image = variant['image']
            }
        }
    }

    // Open graph
    const opengraph = opengraphResolver({
        title,
        description,
        image,
        type
    })

    // Article
    const article = articleResolver({
        author: authorPage,
        createdAt,
        updatedAt: updatedAt || createdAt,
        tags,
        section
    })

    // Twitter
    const twitter = twitterResolver({
        title,
        description,
        image,
        author: authorTwitterNik
    })

    return {
        title: title || 'Ask4Games',
        meta: [
            {
                'property':  'description',
                'name':  'description',
                'content':  description,
            },
            ...opengraph,
            ...article,
            ...twitter
        ]
    }
}
